import * as React from 'react'

import { workflowGlyphIcon } from './WorkflowIconGroups'

interface IProps {
  // Optional because the registry resolves an absent or unknown name to the generic mark, and
  // callers hold workflow data that may not carry one yet.
  iconName?: string
  className?: string
  size?: 'small' | 'medium' | 'large'
}

const SIZE_MAP = {
  small: 16,
  medium: 24,
  large: 32,
}

export default function WorkflowTypeIcon({
  iconName,
  className = '',
  size = 'medium',
}: IProps) {
  // Straight off the registry rather than a scan of the picker's groups: the groups exist to
  // label and order what an admin may choose, and a mark the registry holds but no group offers
  // would otherwise draw as the generic one here while every map surface drew it correctly.
  const Icon = workflowGlyphIcon(iconName)

  return (
    <Icon
      size={SIZE_MAP[size]}
      className={`tw:text-foreground tw:flex-none! ${className}`}
    />
  )
}
